export const ROUTES = {
  DASHBOARD: "/",
  ADMINISTRATION: "/administration",
  LOGIN: "/login",
  OSOS_ONBOARDING: "/osos-onboarding",
  REGISTER: "/register",
  RESET_PASSWORD: "/reset-password",
  ACTIVATE_USER: "/activate-user", // This url set by connio email
  FORGOT_PASSWORD: "/forgot-password",
  DOCUMENTS: "/documents",
  LOGOUT: "/logout",
  SENSORS: "/sensors",
  ALARMS: "/alarms",
  REPORTS: "/reports",
  GENERATION: "/generation",
  SENSOR_COMPARE: "/sensors-compare",
  OSOS: "/osos",
  BILLING_PREDICTION: "/billing-prediction",
  BILLINGS: "/billings",
  BUDGET_PLANNING: "/budget-planning",
  TARIFFS: "/tariffs",
  SUSTAINABILITY: "/sustainability",
  MCP_PREDICTION: "/mcp-prediction",
} as const;
